const myMemberConsumption = []

export default {
  myMemberConsumption
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/records-of-consumption/store/state.js